import { Namespace } from '_core/utils/ssr';

export const workDetailModalConfig = {
  i18nNamespaces: ['briefing', 'portfolio'] as Namespace,
};
